import { createEnv } from '@t3-oss/env-nextjs';
import { vercel } from '@t3-oss/env-nextjs/presets-zod';
import { z } from 'zod';

const env = createEnv({
    extends: [vercel()],

    emptyStringAsUndefined: true,

    client: {
        NEXT_PUBLIC_POSTHOG_KEY: z.string(),
        NEXT_PUBLIC_ZOHO_CRM_ORG_ID: z.string(),
        /** @default false */
        NEXT_PUBLIC_POSTHOG_ENABLED: z
            .enum(['true', 'false'])
            .transform(boolStr => boolStr === 'true'),
        NEXT_PUBLIC_VERCEL_ENV: z
            .enum(['development', 'preview', 'production'])
            .optional()
            .transform(str => str || 'local'),
        /** @default false */
        NEXT_PUBLIC_POSTHOG_CAPTURE_AI_FEEDBACK_TEXT: z
            .enum(['true', 'false'])
            .optional()
            .transform(boolStr => boolStr === 'true')
            .default(false),
    },

    experimental__runtimeEnv: {
        NEXT_PUBLIC_POSTHOG_ENABLED: process.env.NEXT_PUBLIC_POSTHOG_ENABLED,
        NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
        NEXT_PUBLIC_ZOHO_CRM_ORG_ID: process.env.NEXT_PUBLIC_ZOHO_CRM_ORG_ID,
        NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,
        NEXT_PUBLIC_POSTHOG_CAPTURE_AI_FEEDBACK_TEXT:
            process.env.NEXT_PUBLIC_POSTHOG_CAPTURE_AI_FEEDBACK_TEXT,
    },
});

export default env;

export const CONFIG = {
    APP_URL: (() => {
        if (typeof window !== 'undefined') return window.location.origin;
        if (process.env.VERCEL_ENV && process.env.VERCEL_URL) return `https://${process.env.VERCEL_URL}`; // prettier-ignore
        return `http://localhost:${process.env.PORT ?? 3001}`;
    })(),
};
